<era-pane>
  <h5 class="small-caps"
      i18n>Host Name</h5>
  <form [formGroup]="hostNameForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label class="form-label"
             for="hostName">Set the Host Name.</label>
      <input id="hostName"
             formControlName="hostName"
             required="true"
             class="form-control" />
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!hostNameForm.valid">Submit</button>
  </form>
</era-pane>